import {onDocumentReady} from './helpers';
import App from './app';
import DevApp from '../src-dev/app';

// init dev app for development env
if (process.env.NODE_ENV === 'development') {
  (new DevApp()).init();
}

/**
 * init App on document ready
 */
onDocumentReady(() => {
  App.init();
});

/**
 * Make App accessible globally
 * @type {App}
 */
window.sizingApp = App;
